import * as React from 'react';

import { ISchedule } from '~src/schedule/types/ISchedule';
import { cssClass, fillStyle, flexColumnStyle } from '~src/style';
import { IPublishedConnectionDetailInfo } from '~src/ts/models/IPublishedConnectionInfo';
import { IPublishedConnectionTaskInfo } from '~src/ts/models/IPublishedConnectionTaskInfo';
import { PublishedConnectionScheduledTasksGrid } from './PublishedConnectionScheduledTasksGrid';
import { PublishedConnectionTasksActionBar } from './PublishedConnectionTasksActionBar';

const rootClass = cssClass('PublishedConnectionScheduledTasksView', 'root', fillStyle, flexColumnStyle, {
  overflow: 'auto'
});

export const PublishedConnectionScheduledTasksView: React.FC<{
  publishedConnectionDetailInfo: IPublishedConnectionDetailInfo;
}> = ({ publishedConnectionDetailInfo }) => {

  const tasks: ReadonlyArray<IPublishedConnectionTaskInfo> = [];
  const [selectedTasks, setSelectedTasks] = React.useState<ReadonlyArray<IPublishedConnectionTaskInfo>>([]);

  const handleSelectAllTasks = React.useCallback(() => setSelectedTasks(tasks), [tasks]);
  const handleClearTasks = React.useCallback(() => setSelectedTasks([]), []);

  return (
    <div className={rootClass}>
      <PublishedConnectionTasksActionBar
        clearTasks={handleClearTasks}
        publishedConnectionInfo={publishedConnectionDetailInfo}
        selectAllTasks={handleSelectAllTasks}
        selectedTasks={selectedTasks}
      />
      <PublishedConnectionScheduledTasksGrid tasks={tasks}/>
    </div>
  );
};
PublishedConnectionScheduledTasksView.displayName = 'PublishedConnectionScheduledTasksView';
